/**
 * lethal-cart-drawer.js
 * Intercepts the Add to Cart form, adds the item via the Shopify AJAX Cart API,
 * then opens a slide-in drawer showing everything needed before checkout.
 * The Checkout button sends the customer to Shopify's native /checkout page,
 * where all enabled payment methods (Shopify Payments, Shop Pay, etc.) appear
 * automatically. After payment, Shopify redirects to the Order Status page on its own.
 */
(function () {
  'use strict';

  var overlay = document.getElementById('CartDrawerOverlay');
  var closeBtn = document.getElementById('CartDrawerClose');
  var itemsWrap = document.getElementById('CartDrawerItems');
  var countEl = document.getElementById('CartDrawerCount');
  var subtotalEl = document.getElementById('CartDrawerSubtotal');
  var checkoutBtn = document.getElementById('CartDrawerCheckoutBtn');

  if (!overlay) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    countEl.textContent = cart.item_count;
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      checkoutBtn.setAttribute('aria-disabled', 'true');
      return;
    }

    checkoutBtn.removeAttribute('aria-disabled');

    var html = '';
    cart.items.forEach(function (item) {
      html +=
        '<div class="cart-drawer-item">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x120$1$2') : '') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '<div>' +
            '<p class="cart-drawer-item-title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title ? '<p class="cart-drawer-item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<p class="cart-drawer-item-qty">Qty: ' + item.quantity + '</p>' +
          '</div>' +
          '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    itemsWrap.innerHTML = html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function refreshDrawer() {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  // Intercept every Add to Cart form on the page
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-drawer-form]');
    if (!form) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[data-add-to-cart-btn]');
    var btnText = submitBtn ? submitBtn.querySelector('[data-btn-text]') : null;
    var originalText = btnText ? btnText.textContent : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      if (btnText) btnText.textContent = 'Adding...';
    }

    var formData = new FormData(form);

    // Safeguard: some themes leave the variant-id input disabled until their own
    // JS toggles it, which excludes it from FormData and causes Shopify's
    // /cart/add.js to reject the request with "Required parameter missing or
    // invalid: items". Re-read the field directly and force it into the payload.
    var variantIdField = form.querySelector('input[name="id"]');
    if (variantIdField && variantIdField.value) {
      formData.set('id', variantIdField.value);
    }

    if (!formData.get('id')) {
      console.error('Add to cart failed: no variant id found on the form.');
      if (submitBtn) {
        submitBtn.disabled = false;
        if (btnText) btnText.textContent = originalText;
      }
      alert('Please select a valid option before adding to cart.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return refreshDrawer();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        alert((err && err.description) || 'Could not add this item to your cart. Please try again.');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (btnText) btnText.textContent = originalText;
        }
      });
  });

  closeBtn && closeBtn.addEventListener('click', closeDrawer);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeDrawer();
  });

  // Checkout button: goes to Shopify's native checkout page.
  // Shopify Payments and any other enabled gateways show up here automatically,
  // and Shopify redirects to the Order Status (Thank You) page after payment on its own.
  checkoutBtn.addEventListener('click', function (e) {
    if (checkoutBtn.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      return;
    }
    checkoutBtn.setAttribute('href', '/checkout');
  });
})();